(function () {
  "use strict";
  var doc = document, PAGE = doc.querySelector("[data-campaign]") || doc.body;
  var CAMPAIGN = PAGE.getAttribute("data-campaign") || "", VARIANT = PAGE.getAttribute("data-variant") || "";

  /* ---- 1. Campaign parameters: keep them for the product-page link and the cart ---- */
  var KEEP = /^(utm_|fbclid$|gclid$|ttclid$|cs_)/;
  var incoming = new URLSearchParams(location.search), carried = [];
  incoming.forEach(function (v, k) { if (KEEP.test(k)) carried.push([k, v]); });
  if (carried.length) {
    doc.querySelectorAll("a[data-cta]").forEach(function (a) {
      var u = new URL(a.href);
      carried.forEach(function (kv) { if (!u.searchParams.has(kv[0]) || kv[0] === "fbclid") u.searchParams.set(kv[0], kv[1]); });
      a.href = u.toString();
    });
  }

  /* ---- 2. Analytics: dataLayer + Mouseflow tags + DOM event. No vendor code beyond the Mouseflow snippet. ---- */
  function track(name, detail) {
    var payload = Object.assign({ event: "cs_" + name, campaign: CAMPAIGN, variant: VARIANT }, detail || {});
    if (window.dataLayer && typeof window.dataLayer.push === "function") window.dataLayer.push(payload);
    if (window._mfq) { window._mfq.push(["tag", "cs_" + name + (detail && detail.label ? ":" + detail.label : "")]); }
    doc.dispatchEvent(new CustomEvent("cs:track", { detail: payload }));
  }
  if (window._mfq) { window._mfq.push(["setVariable", "cs_campaign", CAMPAIGN]); window._mfq.push(["setVariable", "cs_variant", VARIANT]); }
  doc.addEventListener("click", function (e) {
    var el = e.target.closest("[data-cs-event]");
    if (el && el.getAttribute("data-cs-event") !== "add_to_cart") track(el.getAttribute("data-cs-event"), { label: el.getAttribute("data-cs-label") || "" });
  });
  track("lp_view");
  /* pdp_click: every click through to a product or collection page (the goal of click-through pages) */
  doc.addEventListener("click", function (e) {
    var a = e.target.closest("a[href]"); if (!a) return;
    try { var u = new URL(a.href, location.href); if (/^\/(products|collections)\//.test(u.pathname)) track("pdp_click", { label: a.getAttribute("data-cs-label") || u.pathname }); } catch (err) { /* ignore */ }
  });
  /* Live price and availability on product cards (data-live-handle), for pages that link out instead of selling in place */
  doc.querySelectorAll("[data-live-handle]").forEach(function (card) {
    var h = card.getAttribute("data-live-handle"), store = card.getAttribute("data-store") || ""; if (!h) return;
    fetch(store + "/products/" + h + ".js", { mode: "cors" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var pr = card.querySelector("[data-live-card=price]"), av = card.querySelector("[data-live-card=avail]");
      if (pr) pr.textContent = "$" + (p.price / 100).toLocaleString("en-US", { maximumFractionDigits: 0 });
      if (av) av.textContent = p.available ? "Available now" : "Sold out";
    }).catch(function () { /* keep build-time values */ });
  });

  /* ---- 3. Section views + sticky purchase action (mobile, after the product module is reached) ---- */
  var sticky = doc.querySelector("[data-sticky]"), product = doc.getElementById("product"), finalCta = doc.getElementById("cta") || doc.querySelector("[data-sticky-stop]"), seen = { lp_view: true }, reached = false; /* lp_view already fired on load */
  function updateSticky() {
    if (!product) { var first = doc.querySelector("section[id]"); reached = !!first && first.getBoundingClientRect().bottom < 0; } /* no order box: show once the hero has scrolled away */
    var atFinal = finalCta && finalCta.getBoundingClientRect().top < window.innerHeight * 0.6;
    var inProduct = product && product.getBoundingClientRect().top < window.innerHeight * 0.5 && product.getBoundingClientRect().bottom > window.innerHeight * 0.5;
    var show = reached && !atFinal && !inProduct && window.matchMedia("(max-width: 819px)").matches;
    if (!sticky) return;
    sticky.classList.toggle("is-visible", show); sticky.setAttribute("aria-hidden", show ? "false" : "true");
    sticky.querySelector("a").tabIndex = show ? 0 : -1; doc.body.classList.toggle("has-sticky", show);
  }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = en.target.getAttribute("data-cs-view");
        if (name && !seen[name]) { seen[name] = true; track(name); }
        if (en.target === product) { reached = true; updateSticky(); }
      });
    }, { threshold: 0.2 });
    doc.querySelectorAll("[data-cs-view]").forEach(function (s) { io.observe(s); });
    window.addEventListener("scroll", function () { if (reached || !product) updateSticky(); }, { passive: true });

    /* Section reach: one cs_reach:<section id> tag per section, fired when its top edge passes 60% of the
       viewport. Works for sections of any height. The optimize skill rebuilds each variant's reach curve
       from these tags, in that variant's own section order. */
    var reachSeen = {}, reachIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var id = en.target.id;
        if (!en.isIntersecting || !id || reachSeen[id]) return;
        reachSeen[id] = true; track("reach", { label: id }); reachIo.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -40% 0px", threshold: 0 });
    doc.querySelectorAll("section[id]").forEach(function (s) { reachIo.observe(s); });
  }

  /* ---- 4. Watch chooser: live price/availability, then exact number selection on the product page ---- */
  var form = doc.querySelector("[data-configurator]");
  if (form) {
  var STORE = form.getAttribute("data-store"), HANDLE = form.getAttribute("data-handle");
  var P1 = form.getAttribute("data-engrave-p1"), P2 = form.getAttribute("data-engrave-p2");
  var variants = {};
  function money(cents) { return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
  function selectedVariant() { var r = form.querySelector("input[name=variant]:checked"); return r ? r.value : null; }
  function refreshPrice() {
    var id = selectedVariant(), v = variants[id], r = form.querySelector("input[name=variant]:checked");
    var price = v ? money(v.price) : (r ? r.getAttribute("data-price") : "");
    doc.querySelectorAll("[data-live=price]").forEach(function (n) { n.textContent = price; });
    var st = doc.querySelector("[data-live=price-sticky]"); if (st) st.textContent = price + " · " + (st.getAttribute("data-fulfillment") || "");
    var av = doc.querySelector("[data-live=availability]"); if (av) av.textContent = v ? (v.available ? "In stock" : "Sold out") : "Check on product page";
    var note = doc.querySelector("[data-live=note]"); if (note) note.textContent = v ? "Price and availability are live from the store." : "Confirm current price and availability on the product page.";
    var buy = form.querySelector("button[type=submit]"); if (buy) buy.textContent = "CHOOSE YOUR NUMBER";
    form.querySelector("[data-error=stock]").classList.toggle("is-visible", !!(v && !v.available));
  }
  // This collection uses three separate Shopify products. Verify each watch,
  // including its current variant id, price, and availability.
  form.querySelectorAll("input[name=variant]").forEach(function (input) {
    var url = input.getAttribute("data-url") || STORE + "/products/" + HANDLE;
    var handle = new URL(url, STORE).pathname.split("/").filter(Boolean).pop();
    fetch(STORE + "/products/" + handle + ".js", { mode: "cors" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        // The original pooled variant IDs were replaced by numbered editions.
        // Use a currently available edition for price/stock display only.
        // The visitor chooses the exact number on the watch's product page.
        var v = p.variants.find(function (item) { return item.available; }) || p.variants[0];
        input.value = String(v.id);
        variants[String(v.id)] = v;
        input.setAttribute("data-price", money(v.price));
        if (input.checked) refreshPrice();
      }).catch(function () { /* an unverified choice sends the visitor to its product page */ });
  });
  // Options that are separate products (a collection page) carry their own title, photo and product page link.
  function refreshOption() {
    var r = form.querySelector("input[name=variant]:checked"); if (!r) return;
    var t = r.getAttribute("data-title"), src = r.getAttribute("data-img"), url = r.getAttribute("data-url");
    if (t) doc.querySelectorAll("[data-live=title]").forEach(function (n) { n.textContent = t; });
    var im = doc.querySelector(".lp-product__media img");
    if (im && src && im.getAttribute("src") !== src) { im.src = src; im.alt = r.getAttribute("data-img-alt") || im.alt; }
    var pdp = form.querySelector("[data-live=pdp]");
    if (pdp && url) { var q = pdp.href.indexOf("?"); pdp.href = url + (q > -1 ? pdp.href.slice(q) : ""); }
  }
  form.addEventListener("change", function (e) { if (e.target.name === "variant") { refreshPrice(); refreshOption(); track("variant_select", { label: e.target.value }); } });
  refreshPrice();

  // Engraving: the configurator fields and the engraving-section fields are the same values, kept in sync.
  var toggle = form.querySelector("[data-engrave-toggle]"), fields = form.querySelector("[data-engrave-fields]"), confirmBox = form.querySelector("[data-engrave-confirm]");
  var preview = doc.querySelector("[data-engrave-preview]"), previewText = preview && preview.querySelector(".lp-engrave__text"), cover = preview && preview.querySelector(".lp-engrave__cover"), badge = preview && preview.querySelector("[data-engrave-badge]");
  var interacted = false;
  var firstLine = doc.querySelector("[data-engrave-line]"), MAX = firstLine ? (parseInt(firstLine.getAttribute("maxlength"), 10) || 12) : 12;
  function clean(s) { return s.toUpperCase().replace(/[^A-Z0-9 .,'&#\-]/g, "").slice(0, MAX); }
  function lineValue(n) { var i = doc.querySelector("[data-engrave-line='" + n + "']"); return i ? i.value : ""; }
  function syncLine(n, val, source) {
    doc.querySelectorAll("[data-engrave-line='" + n + "']").forEach(function (i) { if (i !== source) i.value = val; });
    doc.querySelectorAll("[data-count='" + n + "']").forEach(function (c) { c.textContent = val.length; });
    var pv = doc.querySelector("[data-preview='" + n + "']"); if (pv) pv.textContent = val;
    var custom = (lineValue(1) + lineValue(2)).length > 0;
    if (preview) { previewText.hidden = !custom; cover.hidden = !custom; badge.textContent = custom ? "Your engraving (preview)" : "Example engraving"; }
    if (custom && toggle && !toggle.checked) { toggle.checked = true; fields.hidden = false; }
    if (!interacted && custom) { interacted = true; track("engraving_interaction"); }
  }
  doc.addEventListener("input", function (e) {
    var inp = e.target; if (!inp.matches("[data-engrave-line]")) return;
    var val = clean(inp.value); if (val !== inp.value) inp.value = val;
    syncLine(inp.getAttribute("data-engrave-line"), val, inp);
  });
  if (toggle) toggle.addEventListener("change", function () {
    fields.hidden = !toggle.checked;
    if (!toggle.checked) { syncLine("1", "", null); syncLine("2", "", null); doc.querySelectorAll("[data-engrave-line]").forEach(function (i) { i.value = ""; }); confirmBox.checked = false; }
    else { var first = fields.querySelector("[data-engrave-line='1']"); if (first) first.focus(); track("engraving_interaction", { label: "toggle" }); }
    form.querySelector("[data-error=engrave]").classList.remove("is-visible");
  });

  // Route to the selected watch's numbered product page. Adding an arbitrary
  // edition here would silently choose a number for the collector.
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var selected = form.querySelector("input[name=variant]:checked");
    var productUrl = selected && selected.getAttribute("data-url");
    if (!productUrl) return;
    var u = new URL(productUrl, STORE);
    carried.forEach(function (kv) { if (!u.searchParams.has(kv[0])) u.searchParams.set(kv[0], kv[1]); });
    u.searchParams.set("cs_landing_page", CAMPAIGN + "/" + VARIANT);
    track("pdp_click", { label: selected.getAttribute("data-title") || u.pathname });
    location.href = u.toString();
  });
  }
})();
